import React from "react";
import { Card } from "react-bootstrap";

const ModernCard = ({ children, title, subTitle, minHeight = undefined }) => {
  return (
    <Card className="modern-card my-4" style={{ minHeight }}>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        {subTitle && (
          <Card.Subtitle className="mb-2 text-muted">{subTitle}</Card.Subtitle>
        )}
        {children}
      </Card.Body>
    </Card>
  );
};

export default ModernCard;
